import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class CityService {
  monthlyUrl: string = environment.config.monthlyProgress;

  cityUrl: string = environment.config.city;
  apiUrl: string = environment.config.apiUrl;
  vendorSso: string = environment.config.vendorSso;
  cityProfileVendor: string = environment.config.vendorUrl;
  cityProgressUrl: string = environment.config.cityProgress;
  stateProgressUrl: string = environment.config.stateProgress;
  certificateUrl: string = environment.config.certificateUrl;
  urlImage: string = environment.config.staticUrlForImage;
  systemUrl: string = environment.config.systemSettings;
  reportsUrl = environment.config.reports;
  odfUrl = environment.config.odfUrl;
  documentUrl = "";
  constructor(private http: HttpClient) { }

  saveCSP(url: string, data) {
    return this.http.post<any>(this.apiUrl + url, data);
  }
  saveKb(url: string, data) {
    return this.http.post<any>(this.cityUrl + url, data);
  }
  getDetailCSP(url: string, id) {
    return this.http.get<any>(this.apiUrl + url + id);
  }
  getDetailKbById(url: string, id) {
    return this.http.get<any>(this.cityUrl + url + id);
  }
  getListCsp(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }
  getListkb(url: string, queryData) {
    return this.http.get<any>(this.cityUrl + url, { params: queryData });
  }
  deleteCSP(url: string, id) {
    return this.http.delete<any>(this.apiUrl + url + id);
  }
  deleteKb(url: string, id) {
    return this.http.delete<any>(this.cityUrl + url + id);
  }
  updateDoLetter(url: string, id, data) {
    return this.http.put<any>(this.apiUrl + url + id, data);
  }

  updateKb(url: string, id, data) {
    return this.http.post<any>(this.cityUrl + url + id, data);
  }

  submitVerificationForm(url: string, data) {
    return this.http.post<any>(this.cityUrl + url, data);
  }
  getVerificationForm(url: string) {
    return this.http.get<any>(this.cityUrl + url);
  }
  // Common CRUD methods......
  save(url: string, data, params?) {
    return this.http.post<any>(
      this.cityUrl + url,
      data,
      params ? { params } : {},
    );
  }
  updateSHG(url: string, id, data) {
    return this.http.put<any>(this.cityUrl + url + id, data);
  }
  saveSHG(url: string, data, params?) {
    return this.http.post<any>(
      this.cityUrl + url,
      data,
      params ? { params } : {},
    );
  }
  update(url: string, id, data) {
    return this.http.put<any>(this.cityUrl + url + id, data);
  }
  delete(url: string, id) {
    return this.http.delete<any>(this.cityUrl + url + id);
  }
  bannerDelete(url: string, id) {
    return this.http.delete<any>(this.cityUrl + url + id);
  }
  deleteSHG(url: string, id) {
    return this.http.delete<any>(this.cityUrl + url + id);
  }
  getDetail(url: string, id) {
    return this.http.get<any>(this.cityUrl + url + id);
  }
  getSHG(url: string, id) {
    return this.http.get<any>(this.cityUrl + url + id);
  }
  getSHGList(url: string, queryData) {
    return this.http.get<any>(this.cityUrl + url, { params: queryData });
  }
  getList(url: string, queryData) {
    return this.http.get<any>(this.cityUrl + url, { params: queryData });
  }

  getExcelLife(url: string, queryData) {
    return this.http.get<any>(this.cityUrl + url, { params: queryData });
  }

  getExcelfile(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }

  // document
  saveDoc(url: string, data) {
    return this.http.post<any>(this.documentUrl + url, data);
  }
  updateDoc(url: string, id, data) {
    return this.http.put<any>(this.documentUrl + url + id, data);
  }
  deleteDoc(url: string, id) {
    return this.http.delete<any>(this.documentUrl + url + id);
  }
  getDetailDoc(url: string, id) {
    return this.http.get<any>(this.documentUrl + url + id);
  }
  getPlantExcelDownload(url: string, id) {
    return this.http.get<any>(this.apiUrl + url + id);
  }

  //bwg
  bwgExcelDownload(url: string, id) {
    return this.http.get<any>(this.apiUrl + url, { params: id });
  }

  getListDoc(url: string, queryData) {
    return this.http.get<any>(this.documentUrl + url, { params: queryData });
  }

  // Masters
  fetchWardDropdown(id) {
    return this.http.get<any>(this.cityUrl + "master/ward/" + id);
  }
  fetchVehicleDropdown(id) {
    return this.http.get<any>(this.cityUrl + "vehiclemaster/dropdown/" + id);
  }

  fetchZoneDropdown(id) {
    return this.http.get<any>(this.cityUrl + "master/zone/" + id);
  }
  fetchAreaDropdown(id) {
    return this.http.get<any>(this.cityUrl + "master/area/" + id);
  }
  fetchPlantDropDown(query) {
    return this.http.get<any>(this.cityUrl + "swminfrastructure/drop/down", {
      params: query,
    });
  }
  getContactDropDown(filterData) {
    return this.http.get<any>(this.cityUrl + "contact/drop/down", {
      params: filterData,
    });
  }
  getLandfillDropDown(query?) {
    return this.http.get<any>(this.cityUrl + "landFills/drop/down", {
      params: query,
    });
  }
  getDumpsiteDropDown(query?) {
    return this.http.get<any>(this.cityUrl + "dumpSite/drop/down/", {
      params: query,
    });
  }
  getTransferStationDropDown(query?) {
    return this.http.get<any>(this.cityUrl + "transferStation/drop/down/", {
      params: query,
    });
  }
  getWatertBodiesDropDown(query?) {
    return this.http.get<any>(this.cityUrl + "rwa/drop/down/", {
      params: query,
    });
  }

  uploadPhoto(data, base = "cityprofile") {
    return this.http.post<any>(this.apiUrl + `${base}/upload`, data);
  }

  bulkUpload(data) {
    return this.http.post<any>(this.apiUrl + "bulk/upload/", data, {
      observe: "response",
    });
  }
  bulkUploadAreaDynamic(formData: FormData) {
    return this.http.post(
      this.apiUrl + 'cityprofile/area-new/bulkUpload/dynamic',
      formData,
      {
        observe: 'response'
      }
    );
  }
  downloadAreaTemplate(params: any) {
    return this.http.get(
      this.apiUrl + 'cityprofile/area-new/excel/template',
      {
        params: params,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }
  progressList(queryData) {
    return this.http.get(this.cityProgressUrl + "citylevel/basic", {
      params: queryData,
    });
  }

  gfcList(queryData) {
    return this.http.get<any>(this.cityProgressUrl + "gfcList", {
      params: queryData,
    });
  }

  saveMandatory(data) {
    return this.http.post<any>(this.cityProgressUrl + "saveMandatory", data);
  }
  saveEssential(data) {
    return this.http.post<any>(this.cityProgressUrl + "saveEssential", data);
  }
  saveDesirable(data) {
    return this.http.post<any>(this.cityProgressUrl + "saveDesirable", data);
  }

  saveGFC(data) {
    return this.http.post<any>(this.certificateUrl + "gfc", data);
  }
  updateGFC(id, data) {
    return this.http.put<any>(this.certificateUrl + "gfc/" + id, data);
  }
  getGFCList(queryData) {
    return this.http.get<any>(this.certificateUrl + "gfc", {
      params: queryData,
    });
  }
  getGFC(id) {
    return this.http.get<any>(this.certificateUrl + "gfc/" + id);
  }

  saveODF(data) {
    return this.http.post<any>(this.certificateUrl + "odf", data);
  }
  updateODF(id, data) {
    return this.http.put<any>(this.certificateUrl + "odf/" + id, data);
  }
  getODFList(queryData) {
    return this.http.get<any>(this.certificateUrl + "odf", {
      params: queryData,
    });
  }
  getODF(id) {
    return this.http.get<any>(this.certificateUrl + "odf/" + id);
  }

  saveServekshan(data) {
    return this.http.post<any>(this.certificateUrl + "servekshan", data);
  }
  updateServekshan(id, data) {
    return this.http.put<any>(this.certificateUrl + "servekshan/" + id, data);
  }
  getServekshanList(queryData) {
    return this.http.get<any>(this.certificateUrl + "servekshan", {
      params: queryData,
    });
  }
  getServekshan(id) {
    return this.http.get<any>(this.certificateUrl + "servekshan/" + id);
  }

  uploadCertificate(data) {
    return this.http.post<any>(this.certificateUrl + "odf", data);
  }

  saveToiletIHHL(data) {
    return this.http.post<any>(this.stateProgressUrl + "/saveToiletIHHL", data);
  }
  saveToiletCT(data) {
    return this.http.post<any>(this.stateProgressUrl + "/saveToiletCT", data);
  }
  saveToiletPT(data) {
    return this.http.post<any>(this.stateProgressUrl + "/saveToiletPT", data);
  }

  getVendorList(queryData) {
    return this.http.get<any>(this.cityProfileVendor + "cityprofile", {
      params: queryData,
    });
  }
  getVendorListSafiMitra(queryData) {
    queryData.categories =
      '"45180a7b-b1bd-47ff-a302-e41ffa0f6dfb","65278685-3a72-4520-afbe-55ee208962a6"';
    return this.http.get<any>(this.cityProfileVendor + "cityprofile", {
      params: queryData,
    });
  }
  getVendor(id) {
    return this.http.get<any>(this.cityProfileVendor + "cityprofile/" + id);
  }

  saveVendor(data) {
    return this.http.post<any>(this.cityProfileVendor + "cityprofile", data);
  }
  deleteVendor(id) {
    return this.http.delete<any>(this.cityProfileVendor + "cityprofile/", {
      params: id,
    });
  }
  deleteVendorService(id) {
    return this.http.delete<any>(
      this.cityProfileVendor + "cityprofile/service/" + id,
    );
  }
  updateVendor(id, data) {
    return this.http.put<any>(
      this.cityProfileVendor + "cityprofile/" + id,
      data,
    );
  }
  patchVendor(id, data) {
    return this.http.put<any>(
      this.cityProfileVendor + "cityprofile/patch/" + id,
      data,
    );
  }

  getDynamicInput(id) {
    return this.http.get<any>(this.cityUrl + "swminfrastructure/units/" + id);
  }

  getCityDashboardV2(params = {}) {
    return this.http.get<any>(
      environment.config.apiUrl + "dashboard/alphaCity/",
      { params },
    );
  }
  getStateDashboardV2(params = {}) {
    return this.http.get<any>(
      environment.config.apiUrl + "dashboard/alphaState/",
      { params },
    );
  }
  getNationalDashboardV2(params = {}) {
    return this.http.get<any>(
      environment.config.apiUrl + "dashboard/alphaNational/",
      { params },
    );
  }
  getNationalDashboardV3(filterData, params = {}) {
    return this.http.get<any>(
      this.reportsUrl + `SBMDashboard/Dashboards/${filterData}`,
      { params },
    );
  }
  getMonthData(params = {}) {
    return this.http.get<any>(
      environment.config.apiUrl + "dashboard/monthlyprogress",
      { params },
    );
  }

  // bulk upload status
  getBulkUploadStatusList(query) {
    return this.http.get<any>(this.cityUrl + "bulk/upload/", { params: query });
  }
  getModuleList(url: string, params = {}) {
    return this.http.get<any>(this.cityUrl + url, { params });
  }
  getSubModuleList(url: string, queryData) {
    return this.http.get<any>(this.cityUrl + url, { params: queryData });
  }
  // GFC Vendor CRUD methods......
  GfcVendorList(url: string, queryData) {
    return this.http.get<any>(this.vendorSso + url, {
      params: queryData,
      observe: "response",
    });
  }
  GfcVendorDAUser(url: string, queryData = {}) {
    return this.http.get<any>(this.vendorSso + url, { params: queryData });
  }
  GfcRole() {
    return this.http.get<any>(this.vendorSso + "getRoleList");
  }
  verificationQuestionList(url: string, data) {
    return this.http.get<any>(this.systemUrl + url, {
      params: data,
      observe: "response",
    });
  }
  GfcVendorSave(url: string, data) {
    return this.http.post<any>(this.vendorSso + url, data, {
      observe: "response",
    });
  }
  getGfcVendorDetail(url: string, queryData) {
    return this.http.get<any>(this.vendorSso + url, {
      params: queryData,
      observe: "response",
    });
  }
  deleteGfcVendor(url: string, id) {
    return this.http.delete<any>(this.vendorSso + url, {
      params: id,
      observe: "response",
    });
  }
  GfcVendorupdate(url: string, data) {
    return this.http.put<any>(this.vendorSso + url, data, {
      observe: "response",
    });
  }
  getExcel(endpoint, params = {}, fullUrl?: string) {
    const url = fullUrl
      ? this.apiUrl + fullUrl
      : this.monthlyUrl + `report/doc/${endpoint}`;
    return this.http.get<any>(url, { params });
  }

  getExcel1(endpoint, fullUrl?: string) {
    const url = fullUrl
      ? this.apiUrl + fullUrl
      : this.monthlyUrl + `report/doc/${endpoint}`;
    return this.http.get<any>(url);
  }

  getExcelNew(endpoint, params = {}, fullUrl?: string) {
    return this.http.get<any>(this.cityUrl + endpoint, { params });
  }
  CheckPenCount(val: any, params = {}) {
    return this.http.get<any>(
      this.cityUrl + `facilitator/checkpencount/${val}`,
      { params },
    );
  }
  bulkUploadForce(params = {}) {
    return this.http.post<any>(this.cityUrl + "workforcemaster/bulk/", {
      ...params,
    });
  }
  bulkUploadWard(params = {}) {
    return this.http.post<any>(
      this.cityUrl + "workforcemaster/bulkCityProgress/",
      {
        ...params,
      },
    );
  }
  bulkUploadVehicle(params = {}) {
    return this.http.post<any>(this.cityUrl + "vehiclemaster/bulk/", {
      ...params,
    });
  }
  bulkUploadArea(params = {}) {
    return this.http.post<any>(this.cityUrl + "area/excel/upload/", {
      ...params,
    });
  }
  bulkUploadForceMedia(data) {
    return this.http.post<any>(
      environment.config.apiUrl + "media/upload/",
      data,
      { observe: "response" },
    );
  }
  getExcelOdf(endpoint, params = {}) {
    return this.http.get<any>(this.odfUrl + `score-card/doc/${endpoint}`, {
      params,
    });
  }
  getVehicleMasterExcelDownload(url: string) {
    return this.http.get<any>(this.cityUrl + url);
  }
  getIECExcelDownload(url: string, id: string) {
    return this.http.get<any>(this.apiUrl + url + id, {
      observe: "response",
      responseType: "blob" as "json",
    });
  }
  getIECExcelDownloadNational(url: string) {
    return this.http.get<any>(this.apiUrl + url, {
      observe: "response",
      responseType: "blob" as "json",
    });
  }
  // getStateDetails(url: string, id: string) {
  //   return this.http.get<any>(this.proposalUrl + url + id, {
  //     observe: "response",
  //     responseType: "blob" as "json",
  //   });
  // }

  deleteVendorContact(id) {
    return this.http.delete<any>(
      this.cityProfileVendor + "cityprofile/contact/" + id,
    );
  }
  deleteVendorContract(id) {
    return this.http.delete<any>(
      this.cityProfileVendor + "cityprofile/contract/" + id,
    );
  }
  deleteVendorFromList(panNo) {
    return this.http.delete<any>(
      this.cityProfileVendor + "cityprofile/" + panNo,
    );
  }

  // FADR CRUD

  getFadrList(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }

  saveFadr(url: string, data) {
    return this.http.post<any>(this.apiUrl + url, data);
  }

  updateFadr(url: string, id, data) {
    return this.http.put<any>(this.apiUrl + url + id, data);
  }
  updateDistrict(url: string, data) {
    return this.http.put<any>(this.apiUrl + url, data);
  }
  getAssesmentYear(url: string) {
    return this.http.get<any>(this.apiUrl + url);
  }

  getFadrById(url: string, id) {
    return this.http.get<any>(this.apiUrl + url + id);
  }

  deleteFadr(url: string, id) {
    return this.http.delete<any>(this.apiUrl + url + id);
  }

  getListWed(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }

  getListMobiliz(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }

  saveWed(url: string, data, params?) {
    return this.http.post<any>(
      this.apiUrl + url,
      data,
      params ? { params } : {},
    );
  }

  saveMobilization(url: string, data, params?) {
    return this.http.post<any>(
      this.apiUrl + url,
      data,
      params ? { params } : {},
    );
  }
  saveDisMobilization(url: string, id, data) {
    return this.http.post<any>(
      this.apiUrl + url + id,
      data,

    );
  }
  saveDisCapacity(url: string, data) {
    return this.http.post<any>(
      this.apiUrl + url,
      data,

    );
  }
  getMobilization(url: string, id, month, year) {
    return this.http.get<any>(this.apiUrl + url + id + "?month=" + month + '&year=' + year);
  }

  saveWed26(url: string, data, params?) {
    return this.http.post<any>(
      this.apiUrl + url,
      data,
      params ? { params } : {},
    );
  }
  saveTouristArea(url: string, data, params?) {
    return this.http.post<any>(
      this.apiUrl + url,
      data,
      params ? { params } : {},
    );
  }
  updateTouristArea(url: string, id, data, params?) {
    return this.http.post<any>(
      this.apiUrl + url + id,
      data,
      params ? { params } : {},
    );
  }
  saveBasicDistrict(url: string, id, data, params?) {
    return this.http.put<any>(
      this.apiUrl + url + id,
      data,
      params ? { params } : {},
    );
  }

  saveLegacyWaste(url: string, data, params?) {
    return this.http.post<any>(
      this.apiUrl + url,
      data,
      params ? { params } : {},
    );
  }


  getOneTimeLists(url: string, id, queryData) {
    return this.http.get<any>(this.apiUrl + url + id, { params: queryData });
  }

  updateWed(url: string, id, data) {
    return this.http.put<any>(this.apiUrl + url + id, data);
  }
  updateMobilization(url: string, id, data) {
    return this.http.put<any>(this.apiUrl + url + id, data);
  }

  updateDistrictMobilization(url: string, disId, data) {
    return this.http.put<any>(this.apiUrl + url + disId, data);
  }

  getDetailWed(url: string, id) {
    return this.http.get<any>(this.apiUrl + url + id);
  }

  getDistrictMobil(url: string, id, month, year) {
    return this.http.get<any>(this.apiUrl + url + id + "?month=" + month + '&year=' + year);
  }
  getMobilizationDetails(id: number) {
    return this.http.get<any>(
      `${this.apiUrl}iec/worldenvday-2026/mobilization/ulb/details/${id}`
    );
  }
  getCapacityDetails(id: number) {
    return this.http.get<any>(
      `${this.apiUrl}iec/capacity-building/ulb/details/${id}`
    );
  }
  downloadFileWed(url) {
    return this.http.get<any>(this.apiUrl + url);
  }

  downloadExcelDistrictMob(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }
  downloadExcelDistrictCap(url: string) {
    return this.http.get<any>(this.apiUrl + url);
  }

  // SABBC -2025

  getListSabbc2025(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }

  saveSabbc2025(url: string, data, params?) {
    return this.http.post<any>(
      this.apiUrl + url,
      data,
      params ? { params } : {},
    );
  }

  updateSabbc2025(url: string, id, data) {
    return this.http.put<any>(this.apiUrl + url + id, data);
  }

  getDetailSabbc2025(url: string, id) {
    return this.http.get<any>(this.apiUrl + url + id);
  }

  checkWeekValueSabbc2025(url: string, data) {
    return this.http.post<any>(this.apiUrl + url, data);
  }

  fetchProcessingPlantList(query) {
    return this.http.get<any>(
      this.cityUrl + "swminfrastructure/operator/dropdown",
      {
        params: query,
      },
    );
  }
  fetchMaxCapcityDensity(queryData) {
    return this.http.get<any>(
      this.cityUrl + "landFills/landFillDesignCapacity",
      { params: queryData },
    );
  }
  fetchMaxCapcityDensityPlant(queryData) {
    return this.http.get<any>(
      this.cityUrl + "swminfrastructure/plantDesignCapacity",
      { params: queryData },
    );
  }

  checkSmartCities(url: string) {
    return this.http.get<any>(this.apiUrl + url);
  }

  // SSJ Services

  getSsjList(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }

  getMentorDetails(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }

  getSSJDropDownList(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }

  getWomenProfileTypes(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url + "dropdown", {
      params: queryData,
    });
  }

  //   saveNaariLeads(baseUrl: string, data: any) {
  //   return this.http.post(baseUrl, data);
  // }

  getNaariLeadsList(url: string, queryData) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }

  updateNaariLeads(url: string, data, id, params?) {
    return this.http.put<any>(
      this.apiUrl + url + id,
      data,
      params ? { params } : {},
    );
  }

  saveNaariLeads(url: string, data, params?) {
    return this.http.post<any>(
      this.apiUrl + url,
      data,
      params ? { params } : {},
    );
  }

  NaariLeadsById(url: string, id) {
    return this.http.get<any>(this.apiUrl + url + id);
  }

  saveSsjActivity(url: string, data, params?) {
    return this.http.post<any>(
      this.apiUrl + url,
      data,
      params ? { params } : {},
    );
  }

  stateSubmission(url: string, data) {
    return this.http.post<any>(this.apiUrl + url + "state-submission/", data);
  }

  getStateSubmission(url: string) {
    return this.http.get<any>(this.apiUrl + url + "state-submission/");
  }

  getStateSubmissions(url: string, queryData: any) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }

  downloadSubmission(url, id: any) {
    return this.http.get<any>(this.apiUrl + url + id);

  }

  updateSsjActivity(url: string, id, data) {
    return this.http.put<any>(this.apiUrl + url + id, data);
  }

  getSsjDetailById(url: string, id) {
    return this.http.get<any>(this.apiUrl + url + id);
  }

  getDashboardData(url: any, data?: any) {
    return this.http.get(
      this.reportsUrl + "SBMDashboard/" + url + "?stateId=" + (data?.stateId || '')
    );
  }

  getDashboardFilter(url: string, queryData) {
    return this.http.get<any>(this.reportsUrl + url, { params: queryData });
  }

  getDumpsiteData() {
    return this.http.get(
      this.reportsUrl + "SBMDashboard/GMIS-Dashboard-DUMPSITE",
    );
  }

  getMSWData() {
    return this.http.get(
      this.reportsUrl + "SBMDashboard/GMIS-Dashboard-MSW",
    );
  }

  getCADdata() {
    return this.http.get(
      this.reportsUrl + "SBMDashboard/GMIS-Dashboard-CAD",
    );
  }

  getCSTdata() {
    return this.http.get(
      this.reportsUrl + "SBMDashboard/GMIS-Dashboard-CST",
    );
  }

  getNARCHdata(payload?: any) {
    return this.http.get(
      this.reportsUrl + "SBMDashboard/GMIS-Dashboard-NARCH?stateId=" + (payload?.stateId || ''),
    );
  }

  getCSWdata() {
    return this.http.get(
      this.reportsUrl + "SBMDashboard/GMIS-Dashboard-CSW",
    );
  }

  getSanctionedWorkforce() {
    return this.http.get(
      this.apiUrl + "cityprofile/workforcemaster/sanctionedWorkforce"
    );
  }

  getProcessingPlantCapacities(url: string, queryData: any) {
    return this.http.get<any>(this.apiUrl + url, { params: queryData });
  }

  getJmpData(url: string, id: any) {
    return this.http.get<any>(this.apiUrl + url + id);
  }

  getJmpList(url: string, queryData) {
    return this.http.get<any>(this.cityUrl + url, { params: queryData });
  }

  saveJmpData(url: string, data) {
    return this.http.post<any>(
      this.apiUrl + url,
      data,

    );
  }

  fileValidation(data) {
    // return this.http.get<any>(this.mediaUrl + "upload/odf/", { params: data });
    return this.http.post<any>(this.cityUrl + "validate/bulkUpload", data);
  }
  downloadExcelOpPlant(url: string,payload:any) {
    return this.http.get<any>(this.apiUrl + url, { params: payload});
  }
  getRLBs(queryData) {
    return this.http.get<any>(`${this.apiUrl}/districtcollector/gp/monthly/gram/panchayat/dropdown`, {
      params: queryData,
    });
  }
}
